// extracted by mini-css-extract-plugin
module.exports = {"pageWrapper":"UserEventsContainer_pageWrapper__1vzwW","resources":"UserEventsContainer_resources__2CF_W"};